import React, { useEffect } from 'react';

const TermsAndConditions = () => {
  useEffect(() => {
    // Redirect to the static HTML file
    window.location.href = '/terms.html';
  }, []);

  return (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <h2>Loading Terms and Conditions...</h2>
    </div>
  );
};

export default TermsAndConditions;